import React, { FC } from 'react';
import {
  SystemButtonProps,
  SystemButtonDefault,
  SystemButtonContent,
} from '../SystemButton';
import styles from './secondary_button.module.scss';

export const SecondaryButton: FC<SystemButtonProps> = ({
  children,
  onClick,
  disabled,
  iconLeft,
  iconRight,
  type,
  dataName,
  id,
}) => {
  const commonProps = {
    disabled,
    className: styles.secondary,
    name: dataName,
    id,
  };
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
          {children}
        </SystemButtonContent>
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} {...commonProps}>
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </button>
  );
};

SecondaryButton.defaultProps = SystemButtonDefault;
